import './DefaultLegend.scss';
import { ReactNode, Dispatch, SetStateAction } from 'react';
import { MdOutlineWarningAmber } from 'react-icons/md';
import { Size } from '@Components/designConstants';
import { InteractiveDiv } from '@Components/InteractiveEl';
import { Neutral200 as INACTIVE_COLOR } from '../../../../utils/colors';
import { InfoTooltip } from '../../../InfoTooltip';

interface DefaultLegendProps {
  areas: {
    name: string;
    grouping?: { channel: string; platform: string; tactic: string; brand_nonbrand: string };
    incrementality?: boolean;
    toolTip?: string;
    toolTipColor?: string;
    line?: boolean;
  }[];
  activeArea: string | null;
  handleLegendClick: (area: string) => void;
  setHoveredLegend: Dispatch<SetStateAction<string | null>>;
  handleLegendEnter: (area: string) => void;
  hoveredLegend: string | null;
  incrementality?: boolean;
  colorMap: any;
  reverseLegend?: boolean;
  className?: string;
  showDash?: boolean;
  svg?: ReactNode;
}

export const DefaultLegend = ({
  areas,
  activeArea,
  hoveredLegend,
  colorMap,
  handleLegendClick,
  handleLegendEnter,
  incrementality,
  setHoveredLegend,
  reverseLegend,
  className,
  showDash = false,
  svg
}: DefaultLegendProps): ReactNode => {
  const displayedAreas = reverseLegend ? [...areas].reverse() : areas;
  const renderItem = displayedAreas.map(area => {
    const isActiveArea = activeArea === null ? true : activeArea === area.name;
    const isHoveredLegend = hoveredLegend === null ? true : hoveredLegend === area.name;
    const activeColor = isActiveArea ? colorMap?.[area.name] : INACTIVE_COLOR;
    const hoverColor = isHoveredLegend ? colorMap?.[area.name] : INACTIVE_COLOR;
    return (
      <InteractiveDiv
        className='legend-item'
        key={area.name}
        onClick={() => handleLegendClick(area.name)}
        onMouseEnter={() => handleLegendEnter(area.name)}
        onMouseLeave={() => setHoveredLegend(null)}
      >
        <div className='legend-value'>
          <div className={isActiveArea ? '' : 'inactive-legend'}>
            <div style={{ display: 'flex' }}>
              {activeArea === area.name && svg ? (
                <svg className='legend-icon' viewBox='0 0 16 12' preserveAspectRatio='none'>
                  {svg}
                </svg>
              ) : (
                <div
                  className={`legend-icon ${className || ''} ${
                    isActiveArea ? 'active' : ''
                  } ${showDash || area.line ? 'dash' : 'square'}`}
                  style={{
                    backgroundColor: `${activeArea ? activeColor : hoverColor}`
                  }}
                />
              )}
              <div className='legend-header'>
                {area.grouping ? area.grouping.channel : area.name}
              </div>
              {area.toolTip && (
                <div className='tooltip-box'>
                  <InfoTooltip iconColor={area.toolTipColor} size={Size.SM}>
                    {area.toolTip}
                  </InfoTooltip>
                </div>
              )}
              {area.incrementality && incrementality && (
                <MdOutlineWarningAmber
                  style={{
                    color: isActiveArea || activeArea === null ? 'orange' : INACTIVE_COLOR,
                    marginLeft: '5px'
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </InteractiveDiv>
    );
  });
  return <div className='legend'>{renderItem}</div>;
};
